<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-container fluid class="fill-height">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="2" md="2">
          <h1 class="page-title mt-5">Pantallas</h1>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="selectedCountry"
            :items="countries"
            prepend-icon="fa-city"
            class="mt-5"
            label="Seleccionar pais"
            item-text="name"
            item-value=".key"
            aria-autocomplete="false"
            autocomplete="off"
            @change="getCities"
            hide-details
            filled
            rounded
            :allow-overflow="false"
            clearable
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="selectedCity"
            :items="cities"
            prepend-icon="fa-city"
            class="mt-5"
            :disabled="!selectedCountry"
            label="Seleccionar ciudad"
            item-text="name"
            item-value=".key"
            aria-autocomplete="false"
            autocomplete="off"
            hide-details
            @change="getAgencies"
            filled
            rounded
            :allow-overflow="false"
            clearable
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="selectedAgency"
            :items="agencies"
            prepend-icon="fa-city"
            class="mt-5"
            label="Seleccionar sucursal"
            item-text="name"
            item-value=".key"
            aria-autocomplete="false"
            :disabled="!selectedCity"
            autocomplete="off"
            hide-details
            @change="getScreens"
            filled
            rounded
            :allow-overflow="false"
            clearable
          />
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col cols="12" sm="12" md="12">
          <search name="pantallas" />
        </v-col>

        <v-col style="text-align: end" cols="12" sm="12" md="12">
          <v-btn
            color="btn-color"
            class="mt-3 mr-5"
            @click="showAddScreenDialog"
            :loading="loading"
          >
            <v-icon left> fas fa-plus </v-icon>
            Agregar pantalla
          </v-btn>
        </v-col>

        <v-col cols="12" sm="12" md="12">
          <files-table
            @menuClick="handleMenuActions($event)"
            :items="screens"
            :showInfo="true"
            :showEdit="true"
            :showDelete="true"
            :loading="loading"
            :headers="headers"
          />
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-if="deviceStatusDialog"
      persistent
      v-model="deviceStatusDialog"
      max-width="95%"
    >
      <device-status
        :screen="selectedScreen"
        @success="screenAdded"
        @cancel="deviceStatusDialog = false"
      />
    </v-dialog>

    <v-dialog
      v-if="addScreenDialog"
      persistent
      v-model="addScreenDialog"
      max-width="600px"
    >
      <add-screen
        :selectedCountry="selectedCountry"
        :selectedCity="selectedCity"
        :selectedAgency="selectedAgency"
        :key="randomKey"
        :countries="countries"
        :originalScreen="selectedScreen"
        @success="screenAdded"
        @cancel="addScreenDialog = false"
      />
    </v-dialog>

    <v-dialog
      max-width="500px"
      v-if="deleteScreenDialog"
      v-model="deleteScreenDialog"
    >
      <delete-screen
        ref="deleteComponent"
        :name="selectedScreen.name"
        @success="confirmDelete"
        @cancel="deleteScreenDialog = false"
      />
    </v-dialog>
  </div>
</template>
<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import addScreen from "./add-screen";
import deleteScreen from "@/components/delete";
import deviceStatus from "@/components/device-status";
import filesTable from "@/components/files-table";

export default {
  name: "Screens",
  components: {
    addScreen,
    deleteScreen,
    deviceStatus,
    filesTable,
  },
  data() {
    return {
      screens: [],
      snackbarText: "",
      snackbar: false,
      randomKey: 0,
      loading: true,
      addScreenDialog: false,
      selectedScreen: null,
      deleteScreenDialog: false,
      countries: [],
      zones: [],
      headers: [
        {
          text: "Nombre",
          value: "name",
          width: "150px",
        },
        {
          text: "Descripción",
          value: "description",
          width: "150px",
        },

        {
          text: "Zona",
          value: "zoneName",
          width: "150px",
        },
        {
          text: "Fecha de creación",
          value: "createdAt",
          width: "200px",
        },
        {
          value: "options",
          sortable: false,
          align: "end",
          width: "180px",
        },
      ],
      agencies: [],
      cities: [],
      selectedCountry: "",
      selectedCity: "",
      selectedAgency: "",
      deviceStatusDialog: false,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      anim.setSpeed(this.animationSpeed);
    },
    showAddScreenDialog() {
      if (this.selectedAgency) {
        this.randomKey = Math.random();
        this.selectedScreen = null;
        this.addScreenDialog = true;
      } else {
        this.snackbarText = "Seleccione pais, ciudad y sucursal.";
        this.snackbar = true;
      }
    },
    editScreen(item) {
      this.randomKey = Math.random();
      this.selectedScreen = item;
      this.addScreenDialog = true;
    },
    showDeviceStatus(item) {
      this.selectedScreen = item;
      this.deviceStatusDialog = true;
    },
    showDeleteDialog(item) {
      this.selectedScreen = item;
      this.deleteScreenDialog = true;
    },
    getCities(countryId) {
      if (countryId) {
        this.$binding(
          "cities",
          db.collection("cities").where("country", "==", this.selectedCountry)
        );
      } else {
        this.selectedAgency = null;
        this.cities = [];
        this.selectedCity = null;
        this.agencies = [];
        this.screens = [];
      }
    },

    getAgencies(cityId) {
      if (cityId) {
        this.selectedAgency = null;
        let groupId = this.$store.state.groupId;
        this.$binding(
          "agencies",
          db
            .collection("agencies")
            .where("groupId", "==", groupId)
            .where("city", "==", this.selectedCity)
        );
      } else {
        this.selectedAgency = null;
        this.agencies = [];
        this.screens = [];
      }
    },
    handleMenuActions(payload) {
      switch (payload.action) {
        case 1:
          this.editScreen(payload.item);
          break;
        case 2:
          this.showDeleteDialog(payload.item);
          break;
        case 3:
          this.showDeviceStatus(payload.item);
          break;
      }
    },
    async getScreens(agencyId) {
      if (agencyId) {
        this.loading = true;
        let groupId = this.$store.state.groupId;

        await this.$binding(
          "screens",
          db
            .collection("screens")
            .where("groupId", "==", groupId)
            .where("agency", "==", this.selectedAgency)
            .where("selectedApp", "==", "zones")
        );

        this.screens.forEach((screen) => {
          let result = this.zones.find((item) => item[".key"] == screen.zone);
          screen.zoneName = result.name;
        });

        this.loading = false;
      }
    },

    async confirmDelete() {
      this.$refs.deleteComponent.loading = true;
      db.collection("screens")
        .doc(this.selectedScreen[".key"])
        .delete()
        .then((response) => {
          this.snackbarText = "Pantalla borrada exitosamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
          this.deleteScreenDialog = false;
        })
        .catch((error) => {
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.$refs.deleteComponent.loading = false;
        });
    },

    screenAdded() {
      this.addScreenDialog = false;
      this.snackbarText = `Pantalla ${
        this.selectedScreen ? "editada" : "agregada"
      } exitosamente.`;
      this.snackbar = true;
    },
  },
  async mounted() {
    let groupId = this.$store.state.groupId;
    await this.$binding(
      "zones",
      db.collection("zones").where("groupId", "==", groupId)
    );
    await this.$binding("countries", db.collection("countries"));

    this.loading = false;
  },
};
</script>